import React, {useEffect, useRef, useState} from "react";

const BASE = `${process.env.PUBLIC_URL || ""}/rook`;
export const ROOK_IMAGE = `${BASE}/rook.webp`;

const prefersReducedMotion = () =>
    typeof window !== "undefined" && window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

/**
 * Rook the robin. `mood` is "idle", "thinking", "talking", "happy" or "puzzled".
 * The big version breathes, blinks now and then, and its earpiece glows while it thinks.
 */
const RookAvatar = ({mood = "idle", className = "", onClick}) => {
    const [blink, setBlink] = useState(false);
    const timers = useRef([]);

    useEffect(() => {
        if (prefersReducedMotion()) return undefined;
        let alive = true;
        const later = (fn, ms) => timers.current.push(setTimeout(fn, ms));
        const blinkOnce = () => {
            setBlink(true);
            later(() => setBlink(false), 130);
        };
        const schedule = () => later(() => {
            if (!alive) return;
            blinkOnce();
            if (Math.random() < 0.2) later(blinkOnce, 260);
            schedule();
        }, 2500 + Math.random() * 3500);
        schedule();
        return () => {
            alive = false;
            timers.current.forEach(clearTimeout);
            timers.current = [];
        };
    }, []);

    const Tag = onClick ? "button" : "div";
    return (
        <Tag className={`rook-robin ${blink && mood !== "happy" ? "blink" : ""} ${className}`} data-mood={mood}
             onClick={onClick} type={onClick ? "button" : undefined} aria-label={onClick ? "Rook" : undefined}
             aria-hidden={onClick ? undefined : true}>
            <span className="rook-robin__body">
                <img src={ROOK_IMAGE} alt="" draggable="false"/>
                <img className="rook-robin__lid" src={`${BASE}/rook-blink.webp`} alt="" draggable="false"/>
                <img className="rook-robin__smile" src={`${BASE}/rook-happy.webp`} alt="" draggable="false"/>
                <span className="rook-robin__glow"/>
                <span className="rook-robin__led"/>
            </span>
            <span className="rook-robin__think"><i/><i/><i/></span>
            <span className="rook-robin__huh">?</span>
        </Tag>
    );
};

// Small round face for the chat messages
export const RookFace = ({size = 30}) => (
    <span className="rook-face" style={{width: size, height: size, backgroundImage: `url(${ROOK_IMAGE})`}} aria-hidden="true"/>
);

export default RookAvatar;
